import badAfterVestingImage from "../../img/badLeaverAfterVesting.png";
import "./MoreInformation.css";

export const BadAfterVesting = (
  <div className="info-container flex flex-row mr-auto ml-auto">
    <div className="info-column flex flex-column ">
      <text className="sub-title">Bad leaver after the vesting period?</text>
      <text className="paragraph">
        Founders and companies may want to create the possibility to still
        consider a founder a "bad leaver" after the vesting period because the
        company may still be impacted by the actions of a founder even after all
        of his or her shares are vested.
      </text>
      <text className="paragraph">
        For example, if a founder leaves the company after the vesting period
        and joins a direct competitor (in breach of his non compete clause),
        this may harm the company significantly and put the confidential
        information and intellectual property at risk.
      </text>
      <text className="paragraph">
        By including provisions for "bad leavers" after the vesting period, the
        company can ensure that the founder is held accountable for any actions
        that are deemed to be detrimental to the company, even after they have
        completed their vesting period and all of their shares are vested. This
        helps to protect the company's interests.
      </text>
      <text className="paragraph">
        If you opt for keeping the bad leaver provision after the vesting period
        is over, we will provide you with the option of choosing a different
        price for the call option on the shares of bad leaver during the vesting
        period and a bad leaver after the vesting period.
      </text>
    </div>
    <div className="info-column flex">
      <img src={badAfterVestingImage} className="info-image mr-auto ml-auto" />
    </div>
  </div>
);
